import axios from "axios";
const http = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    "Content-type": "application/json",
  },
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("httpError", error.code);
    return Promise.reject(error);
  }
);

export default http;
